export default "__VITE_PUBLIC_ASSET__ed698b06__"